import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * usePatrimonioMaquinaEquipListaFilter
 */

type State = {
  descricao: string;
  status: number;
};

type Action = {
  setDescricao: (descricao?: string) => void,
  setStatus: (status: number) => void,
  clearFilters: () => void
};

export const usePatrimonioMaquinaEquipListaFilter = create<State & Action>((set) => ({
  descricao: "",
  status: 2,
  setStatus: (status) => set({ status }),
  setDescricao: (descricao) => set({ descricao }),
  clearFilters: () => set({
    descricao: "",
    status: 2,
  }),
}));


export const initialFiltersValues: State = {
  descricao: "",
  status: 2,
}